var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('material-alert',{staticClass:"text-center",attrs:{"value":!!_vm.message,"type":"success","dismissible":"","border":"left"},on:{"input":_vm.closeAlert}},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }